module.exports = __webpack_public_path__ + "static/media/MSMEBen5.1e8e1486.svg";